/**
 * Copyright (C) 2010-2026 Kazo Vision. (http://www.kazovision.com)
 * All rights reserved.
 */
import i18n from 'i18next';
import enUS from '@/locales/i18n/en_US.json';
import zhCN from '@/locales/i18n/zh_CN.json';
import { initReactI18next } from 'react-i18next';
// 初始化 i18next
i18n
    .use(initReactI18next) // 将 i18next 与 React 连接
    .init({
    resources: {
        en_US: {
            translation: enUS
        },
        zh_CN: {
            translation: zhCN
        },
    },
    lng: 'zh_CN',
    // debug: process.env.NODE_ENV === 'development',  // 开发环境启用调试
    interpolation: {
        escapeValue: false, // React 已经处理了 XSS
    },
});
export default i18n;
